import React from 'react';
import { Link } from 'react-router-dom';

import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { OutboxOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

type Props = {
  id: string;
};
export default function TemplateActivityLink({ id }: Props) {
  const platformId = useCurrentPlatformId();
  const href = `/o/${platformId}/events?timePeriod=ALL&query=${id}`;
  return (
    <MenuItem component={Link} to={href}>
      <ListItemIcon>
        <OutboxOutlined />
      </ListItemIcon>
      <ListItemText>View activity</ListItemText>
    </MenuItem>
  );
}
